"use client";

import { SWRConfig } from "swr";
import { ReactNode } from "react";

export function SWRProvider({ children }: { children: ReactNode }) {
  return (
    <SWRConfig
      value={{
        shouldRetryOnError: (err) => {
          const statusCode = err?.response?.status ?? err?.code;
          return statusCode !== 401;
        },
        onErrorRetry: (err, _key, _config, revalidate, { retryCount }) => {
          const statusCode = err?.response?.status ?? err?.code;
          if (statusCode === 401) return;
          if (retryCount >= 2) return;
          setTimeout(() => revalidate({ retryCount }), 2000);
        },
      }}
    >
      {children}
    </SWRConfig>
  );
}